import React from 'react';

const StepOtherSharedForRepatriationExpenses = () => (
  <ol>
      <li>
        Approval from the Assistance Provider or Claims Administrator
      </li>
      <li>
        Billing Statement and Proof of Payment from Funeral Home listing costs for each service
      </li>
      <li>
        Paperwork from Embassy/Consulate
      </li>
      <li>
        Copy of the Death Certificate
      </li>
      <li>
        Proof of Travel to include Copy of Passport, Flight Booking and I-94
      </li>
  </ol>);
export default StepOtherSharedForRepatriationExpenses;



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepOther/components/StepOtherSharedForRepatriationExpenses.js